import React, {Component} from 'react'
import styles from './ListFiltered.css'
import moment from 'moment'
import {LIB} from "../../constants/consts-types"
import PropTypes from "prop-types"
import {getMomentLocale} from "../../services/service-moment-locale"

class ButtonOpenCalendar extends Component {
  static propTypes = {
    startDate: PropTypes.object.isRequired,
    resetStartDateCalendar: PropTypes.func.isRequired,
    onOpenCalendar: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.setMomentLocale()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.language !== this.props.language) {
      this.setMomentLocale()
    }
  }

  setMomentLocale() {
    moment.updateLocale(this.props.language, getMomentLocale(this.props.language))
  }

  formatDate() {
    const { startDate, language } = this.props

    if(language === "da") {
      return startDate.format("D. MMM YYYY")
    }

    return startDate.format("D MMM YYYY")
  }

  render() {
    const {
      startDate,
      resetStartDateCalendar,
      onOpenCalendar
    } = this.props

    const dateIsSet = Boolean(startDate.format('l') !== moment().format('l'))

    return (
      <React.Fragment>
        <div className={styles.buttonDatepicker}>
          <button
            aria-label={LIB.select_date_label}
            className={`button secondary ${styles.buttonOpenCalendar}`}
            onClick={onOpenCalendar}
          >
            <span>{this.formatDate()}</span>
            <small className={dateIsSet ? styles.selectDateLabelDateSet : styles.selectDateLabel}>{LIB.select_date_label}</small>
          </button>

          {dateIsSet &&
          <button
            aria-label={LIB.reset_calendar_date}
            className={`close ${styles.buttonClear}`}
            onClick={resetStartDateCalendar}
          >
            <span>&times;</span>
          </button>
          }
        </div>
      </React.Fragment>
    )
  }
}

export default ButtonOpenCalendar



// WEBPACK FOOTER //
// ./src/components/ListFiltered/ButtonOpenCalendar.js